import { createContext } from 'react';
import { IBestTime } from '../../api';

export interface ITime {
  id: number;
  userId: number;
  level: 1 | 2 | 3;
  time: number;
  date: number;
}

export interface IConfig {
  openGameChooser: boolean;
  openProfile: boolean;
  user: {
    country: string;
    name: string;
    windowsId: string;
    id: number;
    lastGames: ITime[];
    bestTimes: {
      best1: IBestTime[],
      best2: IBestTime[],
      best3: IBestTime[],
    },
    best1: ITime[];
    best2: ITime[];
    best3: ITime[];
  }
}

export interface IConfigHook {
  config: IConfig;
  setConfig: (config: IConfig) => void;
}

export const defaultConfig: IConfig = {
  openGameChooser: true,
  openProfile: false,
  user: {
    country: 'US',
    name: '',
    windowsId: '',
    id: 0,
    lastGames: [],
    bestTimes: {
      best1: [],
      best2: [],
      best3: [],
    },
    best1: [],
    best2: [],
    best3: [],
  }
};

export const defaultConfigContext: IConfigHook = {
  config: defaultConfig,
  setConfig: (config: IConfig) => void 0,
};

export default createContext(defaultConfigContext);